import { createSlice } from '@reduxjs/toolkit';
import { DashboardStore } from 'types/dashboard';

// initial state
const initialState: DashboardStore = {
    selectedDashboard: undefined,
    dashboardList: [],
    isLoading: true
};

// ==============================|| SLICE - DASHBOARD ||============================== //

const dashboard = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashboardList(state, action) {
            state.dashboardList = action.payload;
        },

        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },

        setSelectedDashboard(state, action) {
            state.selectedDashboard = action.payload;
        }
    }
});

export default dashboard.reducer;

export const { setDashboardList, setSelectedDashboard, setIsLoading } = dashboard.actions;
